import axios from 'axios'
import { API_BASE_URL } from './constants'
import type {
	PortfolioTask,
	PortfolioTaskCreateInput,
	PortfolioTaskUpdateInput,
} from '../types/portfolioTask'

/**
 * Backend: backend/controllers/portfolioTaskCNController.js
 * Routes  : backend/routes/portfolioTaskCNRoutes.js
 */

const authConfig = (token: string) => ({
	headers: { Authorization: `Bearer ${token}` },
})

export const getPortfolioTasks = async (
	portfolioId: string,
	token: string,
): Promise<PortfolioTask[]> => {
	const { data } = await axios.get<PortfolioTask[]>(
		`${API_BASE_URL}/portfoliotaskcns`,
		{ ...authConfig(token), params: { portfolioid: portfolioId } },
	)
	return data
}

export const createPortfolioTask = async (
	input: PortfolioTaskCreateInput,
	token: string,
): Promise<PortfolioTask> => {
	const { data } = await axios.post<PortfolioTask>(
		`${API_BASE_URL}/portfoliotaskcns`,
		input,
		authConfig(token),
	)
	return data
}

export const updatePortfolioTask = async (
	taskId: string,
	patch: PortfolioTaskUpdateInput,
	token: string,
): Promise<PortfolioTask> => {
	const { data } = await axios.put<PortfolioTask>(
		`${API_BASE_URL}/portfoliotaskcns/${taskId}`,
		patch,
		authConfig(token),
	)
	return data
}

export const deletePortfolioTask = async (
	taskId: string,
	token: string,
): Promise<void> => {
	await axios.put(
		`${API_BASE_URL}/portfoliotaskcns/${taskId}/delete`,
		{},
		authConfig(token),
	)
}
